export default "/assets/modules/images/Recommendation-Profile.svg?3763d94344a974caf3c52b13f3a7b864";